import { __read } from 'tslib';
import { createContext } from '../utils/createContext.js';

var _a = __read(createContext({
    name: "Dropdown",
}), 2), useDropdownContext = _a[0], DropdownContext = _a[1];
var DropdownConsumer = DropdownContext.Consumer;
var DropdownProvider = DropdownContext.Provider;

export { DropdownConsumer, DropdownProvider, useDropdownContext };
//# sourceMappingURL=DropdownProvider.js.map
